<ng-container *ngIf="!isInHeader">

  <div class="available-rooms-title">
    <ng-container i18n>Available Rooms</ng-container>
  </div>


 <ng-container *ngIf="hostel && !hostel?.minRate && !isInHeader && !hostel?.hyperguestPropertyId" >
  <div class="no-availability-component">
    <div class="no-availability-bubble">
      <div class="icon-container">
        <div class="icon-background">
          <svg-icon
            [svgStyle]="{ 'width.px': 21.5, 'height.px': 21.5 }"
            src="/assets/icons/info.svg"
          ></svg-icon>
        </div>
      </div>
      <div class="no-availability-message">
        <ng-container>
          We have no availability on our site for this property between
        </ng-container>
        <div class="no-availability-title">
          {{ bookingOptions?.checkInDate | date: 'EEE, MMM d, y' }}
        </div>
        <ng-container>
            and
        </ng-container>
        <div class="no-availability-title">
          {{ bookingOptions?.checkOutDate | date: 'EEE, MMM d, y' }}
        </div>
        <div class="no-availability-subtext">
          <ng-container >
            Select different dates to see more availability.
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
</ng-container>



<div class="chips" [ngClass]="{'header-filters': isInHeader}">
  <ng-container *ngIf="isInHeader; else defaultLayout">
    <form [formGroup]="searchForm">
      <div class="chip">
        <app-where formControlName="where" id="where" (click)="setActiveInput('where')" [active]="activeInput === 'where'"></app-where>
      </div>
    </form>
    <div class="chip" (click)="openCalendar()">
      <svg-icon src="/assets/icons/Calendar.svg"></svg-icon>
      <span>{{ bookingOptions?.checkInDate | date: 'EEE, MMM d' }} - {{ bookingOptions?.checkOutDate | date: 'EEE, MMM d' }}</span>
    </div>
    <div class="chip who" (click)="noOfGuestsFocused.next(true)" (outsideClick)="noOfGuestsFocused.next(false)">
      <ng-container *ngIf="!(noOfGuestsFocused | async)">
        <ng-container *ngIf="bookingOptions">
          <svg-icon src="/assets/icons/guest.svg"></svg-icon>
          <span>{{bookingOptions.noOfGuests}} {{ bookingOptions.noOfGuests === 1 ? 'guest' : 'guests' }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="noOfGuestsFocused | async">
        <span class="input-end">
          <button [disabled]="bookingOptions.noOfGuests <= 1" (click)="decrement()" style="display: flex">
            <svg-icon style="height: 22px" [svgStyle]="{'width.px': 22, 'height.px': 22}" src="/assets/icons/minus.svg"></svg-icon>
          </button>
          <div class="count">
            <span>{{bookingOptions.noOfGuests}}</span>
          </div>
          <button (click)="increment()" style="display: flex">
            <svg-icon style="height: 22px" [svgStyle]="{'width.px': 22, 'height.px': 22}" src="/assets/icons/plus.svg"></svg-icon>
          </button>
        </span>
      </ng-container>
    </div>
    <div class="chip search-chip" (click)="goToSearchResults()">
      <svg-icon src="/assets/icons/search.svg"></svg-icon>
      <ng-container i18n>Search</ng-container>
    </div>
  </ng-container>
  <ng-template #defaultLayout>
    <div class="chip" (click)="openCalendar()">
      <ng-container i18n>
        Check in:&nbsp;
      </ng-container>
      <ng-container *ngIf="bookingOptions">
        <span>{{bookingOptions.checkInDate | date:'EEEE, MMMM d, y' }}</span>
      </ng-container>
      <ng-container *ngIf="!bookingOptions">
        <div class="skeleton"></div>
      </ng-container>
    </div>
    <div class="chip" (click)="focused.next(true)">
      <ng-container i18n>
        Check out:&nbsp;
      </ng-container>
      <ng-container *ngIf="bookingOptions">
        <span>{{bookingOptions.checkOutDate | date:'EEEE, MMMM d, y' }}</span>
      </ng-container>
      <ng-container *ngIf="!bookingOptions">
        <div class="skeleton"></div>
      </ng-container>
    </div>
    <div class="chip who" (click)="noOfGuestsFocused.next(true)" (outsideClick)="noOfGuestsFocused.next(false)">
      <ng-container i18n>
        Guests:&nbsp;&nbsp;
      </ng-container>
      <ng-container *ngIf="!(noOfGuestsFocused | async)">
        <ng-container *ngIf="bookingOptions">
          <span>{{bookingOptions.noOfGuests}} {{ bookingOptions.noOfGuests === 1 ? 'guest' : 'guests' }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="noOfGuestsFocused | async">
        <span class="input-end">
          <button [disabled]="bookingOptions.noOfGuests <= 1" (click)="decrement()" style="display: flex">
            <svg-icon style="height: 22px" [svgStyle]="{'width.px': 22, 'height.px': 22}" src="/assets/icons/minus.svg"></svg-icon>
          </button>
          <div class="count">
            <span>{{bookingOptions.noOfGuests}}</span>
          </div>
          <button (click)="increment()" style="display: flex">
            <svg-icon style="height: 22px" [svgStyle]="{'width.px': 22, 'height.px': 22}" src="/assets/icons/plus.svg"></svg-icon>
          </button>
        </span>
      </ng-container>
    </div>
  </ng-template>
</div>
<!-- when day is clicked, if there is an unavailable day after that day, just disable all until that unavailable day is reached! -->

<ng-container *ngIf="focused | async">
  <div class="calendar-wrapper" (outsideClick)="setFocus(false)">
    <div class="calendar-content">
      <div class="card calendar">
        <div class="top">
          <div class="calendar-from">
            <div class="control">
              <button class="btn month-control-btn" (click)="previousMonth()" [disabled]="monthOffset < 1">
                <svg-icon src="/assets/icons/left.svg"></svg-icon>
              </button>
            </div>
            <div class="month">
              <div class="title">
                {{ fromMonth | month }} {{ fromYear }}
              </div>
              <div class="days">
                <div>
                  <span>S</span>
                </div>
                <div>
                  <span>M</span>
                </div>
                <div>
                  <span>T</span>
                </div>
                <div>
                  <span>W</span>
                </div>
                <div>
                  <span>T</span>
                </div>
                <div>
                  <span>F</span>
                </div>
                <div>
                  <span>S</span>
                </div>
              </div>
              <div class="dates">
                <ng-container *ngFor="let i of days;">
                  <ng-container *ngIf="(i > fromStartDay!) && ((i - fromStartDay!) <= fromDays!); else empty">
                    <app-day
                      [attr.data-i]="i"
                      [noAvailability]="noAvailability"
                      [attr.data-date]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                      (dayMouseenter)="highlight(i)"
                      (dayMouseleave)="unhighlight()"
                      (dayClick)="clicked(i, i - fromStartDay, true)"
                      [i]="i"
                      [dateValue]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                      [anchorStart]="anchorStart"
                      [(anchorStartDate)]="anchorStartDate"
                      [anchorEnd]="anchorEnd"
                      [(anchorEndDate)]="anchorEndDate"
                      [(selecting)]="selecting"
                      [firstDayOfMonth]="fromStartDay"
                      [daysInMonth]="fromDays"
                      [toStartDay]="toStartDay"
                      [fromStartDay]="fromStartDay"
                      [monthOffset]="monthOffset"
                      [absoluteAnchorStart]="absoluteAnchorStart"
                      [absoluteAnchorEnd]="absoluteAnchorEnd"
                      [focus]="focus"
                      [month]="'from'"
                      [fromMonth]="fromMonth"
                      [toMonth]="toMonth"
                      [unavailableDates]="unavailableDates"
                      >
                      <span>{{ i - fromStartDay! }}</span>
                    </app-day>
                  </ng-container>
                  <ng-template #empty>
                    <div class="date date-empty">
                      <span></span>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="calendar-to">
            <div class="month">
              <div class="title">
                {{ toMonth | month }} {{ toYear }}
              </div>
              <div class="days">
                <div>
                  <span>S</span>
                </div>
                <div>
                  <span>M</span>
                </div>
                <div>
                  <span>T</span>
                </div>
                <div>
                  <span>W</span>
                </div>
                <div>
                  <span>T</span>
                </div>
                <div>
                  <span>F</span>
                </div>
                <div>
                  <span>S</span>
                </div>
              </div>
              <div class="dates">
                <ng-container *ngFor="let i of days;">
                  <ng-container *ngIf="i - 1 >= toStartDay! && (i - toStartDay) <= toDays!; else empty">
                    <app-day
                      [attr.data-i]="i + 40"
                      [noAvailability]="noAvailability"
                      [attr.data-date]="i | dayToDate : toMonth : toStartDay : toYear"
                      (dayMouseenter)="highlight(i + 40)"
                      (dayMouseleave)="unhighlight()"
                      (dayClick)="clicked(i + 40, i - toStartDay)"
                      [i]="i + 40"
                      [dateValue]="i | dayToDate : toMonth : toStartDay : toYear"
                      [anchorStart]="anchorStart"
                      [(anchorStartDate)]="anchorStartDate"
                      [anchorEnd]="anchorEnd"
                      [(anchorEndDate)]="anchorEndDate"
                      [(selecting)]="selecting"
                      [firstDayOfMonth]="toStartDay"
                      [daysInMonth]="toDays"
                      [toStartDay]="toStartDay"
                      [fromStartDay]="fromStartDay"
                      [monthOffset]="monthOffset"
                      [absoluteAnchorStart]="absoluteAnchorStart"
                      [absoluteAnchorEnd]="absoluteAnchorEnd"
                      [focus]="focus"
                      [month]="'to'"
                      [fromMonth]="fromMonth"
                      [toMonth]="toMonth"
                      [unavailableDates]="unavailableDates"
                      >
                      <span>{{ i - toStartDay }}</span>
                    </app-day>
                  </ng-container>
                  <ng-template #empty>
                    <div class="date date-empty">
                      <span></span>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
            <div class="control">
              <button class="btn month-control-btn" (click)="nextMonth()" [disabled]="monthOffset >= 4">
                <svg-icon src="/assets/icons/right.svg"></svg-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="buttons">
            <button class="btn btn-frame">
              Clear
            </button>
            <button
              class="btn btn-theme"
              [ngClass]="{'disabled': !startDate || !endDate}"
              [disabled]="!startDate || !endDate"
              (click)="doUpdate();close();">
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
